/* eslint-disable no-param-reassign */
import BulkValidator from './bulkValidator';
import { rules } from './validation-rules';

const labels = {
    sku: 'SKU',
    quantity: 'Quantity',
};

const duplicateErr = {
    sku: 'The SKU is duplicate.',
};

function checkDuplication(item, items) {
    const dup = { sku: false };
    items.some((i) => {
        if (i !== item) {
            if (!dup.sku) {
                dup.sku = i.sku && i.sku === item.sku && i.lotNumber === item.lotNumber && i.expirationDate === item.expirationDate;
            }
        }
        return dup.sku; // stops looping if both true
    }, {});
    return dup;
}

function uniquenessValidator(row, status, data) {
    const duplicates = checkDuplication(row, data);
    if (!duplicates.sku) {
        return;
    }
    status.$valid = false;
    Object.entries(duplicates).forEach(([key, duplicate]) => {
        if (duplicate) {
            const field = status[key] || { valid: false, errors: [] };
            field.valid = false;
            const errMsg = duplicateErr[key];
            if (!field.errors.includes(errMsg)) {
                field.errors.push(errMsg);
            }
            status[key] = field;
        }
    });
}

function findDuplicates(items) {
    const uniqueMap = {};
    const duplicates = {};

    items.forEach(({ idx, sku }) => {
        const skuDuplicate = uniqueMap[`S^${sku}`.toLowerCase()];
        if (!skuDuplicate || !sku) {
            uniqueMap[`S^${sku}`.toLowerCase()] = idx;
        } else {
            if (!duplicates[idx]) {
                duplicates[idx] = { sku: true };
            } else {
                duplicates[idx].sku = true;
            }
            if (!duplicates[skuDuplicate]) {
                duplicates[skuDuplicate] = { sku: true };
            } else {
                duplicates[skuDuplicate].sku = true;
            }
        }
    });

    return duplicates;
}

function uniquenessReValidator(row, status, data, duplicates) {
    if (!status) {
        return;
    }

    const duplication = duplicates[row.idx] || { sku: false };

    Object.entries(duplication).forEach(([key, duplicate]) => {
        const field = status[key] || { valid: false, errors: [] };
        const errMsg = duplicateErr[key];
        if (duplicate) {
            if (!field.errors.includes(errMsg)) {
                field.errors = [...field.errors, errMsg];
            }
        } else {
            field.errors = field.errors.filter(msg => msg !== errMsg);
        }
        field.valid = !field.errors.length;
        status[key] = field;
    });

    status.$valid = !Object.values(status).some(val => typeof val === 'object' && val.valid === false);
}

function reValidateCustom(data, result) {
    const duplicates = findDuplicates(data);
    return data.map((item, i) => {
        const { idx } = item;
        const res = result[i] && result[i].idx === idx && result[i];
        const status = res || result.find(s => s.idx === idx) || { $valid: true, idx };
        uniquenessReValidator(item, status, data, duplicates);
        return status;
    });
}

export default class ItemsBulkValidator {
    constructor() {
        this.validator = new BulkValidator(rules, labels, uniquenessValidator);
    }

    /**
     * @param data
     * @returns {Promise<Object[]>}
     */
    validate(data = []) {
        return this.validator.validate(data || []);
    }

    async reValidate(row, field, data = [], oldResults) {
        const result = [...oldResults];

        if (!row) {
            return reValidateCustom(data, result);
        }
        const status = await this.validator.validateRow(row, null, null, data || []);
        const { idx } = status;
        const oldStatus = result.find(s => s.idx === idx);
        if (oldStatus) {
            Object.assign(oldStatus, status);
        }
        if (['sku'].includes(field)) {
            return reValidateCustom(data, result);
        }
        return result;
    }
}
